export default [
    {
		path: "/settings/users",
		component: () => import("../views/Settings/Users/Home.vue"),
		meta: {
			hasmainmenu: true
		}
	},
	{
		path: "/settings/users/create",
		component: () => import("../views/Settings/Users/Create.vue")
	},
	{
		path: "/settings/users/update/:userId",
		component: () => import("../views/Settings/Users/Update.vue")
	},
	{
		path: "/settings/users/roles",
		component: () => import("../views/Settings/Users/Roles/Home.vue"),
		meta: {
			hasmainmenu: true
		}
	},
	{
		path: "/settings/users/roles/create",
		component: () => import("../views/Settings/Users/Roles/Create.vue"),
	},
	{
		path: "/settings/users/roles/update/:roleId",
		component: () => import("../views/Settings/Users/Roles/Update.vue"),
	},
]
